import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import ServiceDetail from "./pages/ServiceDetail";
import Layout from "./components/Layout"
import ProductDetail from "./pages/ProductDetail";
import ProductTerms from "./pages/ProductTerms";
import CodeOfPractice from "./pages/CodeOfPractice";
// import NotFound from "./pages/NotFound";

function App() {
  return (
    <Routes>
      <Route path="/" element={ <Layout />}>
        <Route path="/" element={<Home />} />
        {/* <Route path="/services" element={<Services />} /> */}
        <Route path="services/:serviceName" element={<ServiceDetail />} />
        <Route path="services/:serviceName/:productName" element={<ProductDetail />} />
        <Route path="services/:serviceName/:productName/terms" element={<ProductTerms />} />
        <Route path="code-of-practice" element={<CodeOfPractice />} />
        <Route path="*" element={<Home />} />
      </Route>
    </Routes>
  );
}

export default App;
